import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer";
import Graphic from "@arcgis/core/Graphic";
import Point from "@arcgis/core/geometry/Point";
export function getLayer(mapView, id) {
    let layer = mapView.map.layers.find(function (l) {
        return l.id === id;
    });
    return layer;
}
export function addGraphicLayer(name, mapView) {
    let graphicLayer = getLayer(mapView, name + "graphicLayer");
    if (graphicLayer === undefined) {
        graphicLayer = new GraphicsLayer({
            id: name + "graphicLayer"
        });
        mapView.map.add(graphicLayer);
    }
    return graphicLayer;
}
export function addGraphicToMap(graghicToMap) {
    if (graghicToMap.mapView && graghicToMap.mapView.graphics.length > 0) {
        graghicToMap.mapView.graphics.removeAll();
    }
    let _geomerty = graghicToMap.feature.geometry || graghicToMap.feature;
    var graphic = new Graphic({
        geometry: _geomerty,
        attributes: graghicToMap.feature.attributes || graghicToMap.feature
    });
    switch (_geomerty.type) {
        case "polygon":
            graphic.symbol = graghicToMap.polygonSymbol();
            break;
        case "polyline":
            graphic.symbol = graghicToMap.polylineSymbol();
            break;
        case "point":
            graphic.symbol = graghicToMap.pointSymbol();
            break;
    }
    graghicToMap.mapView.graphics.add(graphic);
}
export function createGeometryPoint(point) {
    let geometry = new Point({
        x: point.x,
        y: point.y,
        spatialReference: point.spatialReference
    });
    return geometry;
}
export function addGraphic(addGraghicToLayer) {
    if (addGraghicToLayer.clear) {
        addGraghicToLayer.layer.removeAll();
    }
    let geomerty = addGraghicToLayer.feature.geometry || addGraghicToLayer.feature;
    var graphic = new Graphic({
        geometry: geomerty,
        attributes: addGraghicToLayer.feature.attributes || addGraghicToLayer.feature
    });
    switch (geomerty.type) {
        case "polygon":
            graphic.symbol = addGraghicToLayer.polygonSymbol();
            break;
        case "point":
            graphic.symbol = addGraghicToLayer.imageSymbol();
            break;
    }
    addGraghicToLayer.layer.add(graphic);
}
